(function () {
  function redirectToProduct(opener) {
    var scope = opener.closest('.product-card, .content-item');
    var link = scope && scope.querySelector('a[href*="/products/"]');
    if (link && link.href) {
      window.location.href = link.href;
    }
  }

  function patchQuickAdd() {
    var ModalClass = customElements.get('quick-add-modal');
    if (!ModalClass || ModalClass.prototype.show.__bnexoPatched) {
      return;
    }

    var originalShow = ModalClass.prototype.show;
    ModalClass.prototype.show = function (opener) {
      opener.setAttribute('aria-disabled', 'true');
      opener.classList.add('loading');
      var spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }

      fetch(opener.getAttribute('data-product-url'))
        .then(function (response) {
          return response.text();
        })
        .then(function (responseText) {
          var responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          if (!this.productElement) {
            redirectToProduct(opener);
            return;
          }

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }

          this.preventVariantURLSwitching();
          ModalDialog.prototype.show.call(this, opener);
        }.bind(this))
        .finally(function () {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) {
            spinner.classList.add('hidden');
          }
        });
    };

    ModalClass.prototype.show.__bnexoPatched = true;
  }

  function initCardClicks() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) {
        return;
      }
      if (e.target.closest('a, button, modal-opener, input, select, label')) {
        return;
      }

      var card = e.target.closest('.product-card');
      if (!card) {
        return;
      }

      var link = card.querySelector('a.product-card__heading, a.product-card__image');
      if (link && link.href) {
        window.location.href = link.href;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchQuickAdd();
      initCardClicks();
    });
  } else {
    patchQuickAdd();
    initCardClicks();
  }

  document.addEventListener('shopify:section:load', patchQuickAdd);
})();
